import { APIAddress } from "@companion-core/shared/app/Interfaces/API";

export interface RequestProposalCardProps {
  testID?: string;
  id?: string;
  icon?: string;
  iconOverlay?: string;
  media?: string;
  mediaAlt?: string;
  title?: string;
  subtitle?: string;
  status?: string;
  displaySkeleton?: boolean;
  beginningAddress?: APIAddress;
  endingAddress?: APIAddress;
  budget?: string;
  ariaLabel?: string;
  href?: string;
  tracked?: boolean;
  nbItems?: number;
  position?: number;
  vendorId?: string;
  url?: string;
  variant?: RequestProposalCardVariant;
  className?: string;
  style?: unknown;
  onClick?: () => void;
  onPress?: () => void;
}

export enum RequestProposalCardVariant {
  Proposal = "proposal",
  ModifyReservation = "modify_reservation",
}

export interface UseRequestProposalCardProps {
  id?: string;
  position?: number;
  nbItems?: number;
  url?: string;
  format: boolean;
  variant?: RequestProposalCardVariant;
  vendorId?: string;
}
